import React from 'react'
import VisibilitySensor from '../VisibilitySensor'
import Content from './Content'
import { makeStyles } from '@material-ui/core/styles'
import { CaratteristichePageConfig } from '../../configuration'
import AssignId from '../AssignId'

const styles = theme => ({
    wrapper: {
        [theme.breakpoints.up(theme.breakpoints.values.xs + 1920)]: {
            display: 'flex',
            justifyContent: 'center'
        }
    },
    root: {
        padding: '90px',
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        position: 'relative',
        maxWidth: '1920px',
        flexDirection: 'column',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1360)]: {
            padding: '90px 50px'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 840)]: {
            padding: '90px 2rem'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
            padding: '105px 1rem'
        }
    }
})

const useStyles = makeStyles(styles)

export default function Caratteristiche() {
    const classes = useStyles()
    return (
        <div className={classes.wrapper} id='7'>
            <div className={classes.root} >
                <AssignId
                    absolute
                    y='-50px'
                    yMobile='0'
                    id={CaratteristichePageConfig.slug}
                />
                <Content
                    primaryText={CaratteristichePageConfig.content.primary}
                    secondaryText={CaratteristichePageConfig.content.secondary}
                    // expandedText={CaratteristichePageConfig.content.expanded}
                />
                <VisibilitySensor index={7} />
            </div>
        </div>
    )
}